import { getAuth, signInWithCustomToken } from 'firebase/auth'
import { logToAnalytics } from 'modules'
import * as Sentry from '@sentry/react'
import { useEffect } from 'react'

const onWindowMessage = async (e: any) => {
    if (!e.data) {
        console.error('[onWindowMessage] Data is not available:', e)
        return
    }

    const token = e.data?.token
    if (!token) return

    try {
        await signInWithCustomToken(getAuth(), token).then(userCredential => {
            logToAnalytics('sso-login', {
                providerId: userCredential.providerId,
                email: userCredential.user.email,
                id: userCredential.user.uid,
            })
        })
    } catch (e) {
        Sentry.captureException(new Error('sso-login-failed'), {
            extra: {
                props: (e as any).data,
                error: e,
            },
        })
    }
}

export const useListenForSsoLogin = () => {
    useEffect(() => {
        window.addEventListener('message', onWindowMessage)

        return () => {
            window.removeEventListener('message', onWindowMessage)
        }
    }, [])
}
